import React from "react";
import Typography from "@material-ui/core/Typography";
const Setup = ({}) => {
  return (
    <React.Fragment>
      <Typography paragraph variant="h4">
        Setup
      </Typography>
      <Typography paragraph variant="h5">
        Organize the system's default values and configuration
      </Typography>
      <Typography paragraph variant="body1">
        Setup is the fundamental feature for all modules to organize some basic
        master data and rules used for the business process. It contains
        configuration about the currencies, countries, and fiscal years used for
        the company, the unit of measurement & variants used by the product,
        until the document naming convention and its approval process.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        How it works
      </Typography>
      <Typography paragraph variant="body1">
        The first information displayed on this setup feature is the Company
        Profile Setup. There are 3 tabs under the Company Profile Setup, the
        first one is Basic Info which contains the company information like the
        company name, the base currency used, the address details, the server
        timezone, and the company logo. The second tab is License which contains
        information like the platform version used, the license type, and the
        platform estimation cost. The third tab is Themes which contains the
        company's custom wallpaper themes uploaded into the system. Apart from
        the Company Profile Setup, there are more configurations provided in
        list below which allow the company to adjust the platform setting and
        default values based on their needs.
      </Typography>
      <Typography paragraph variant="body1">
        <b>CRM Setup</b>
        <ul>
          <li>
            <b>Priority</b>
          </li>
          <li>
            <b>SLC Status</b>
          </li>
          <li>
            <b>Sales Activity</b>
          </li>
        </ul>
      </Typography>
      <Typography paragraph variant="body1">
        <b>Customer Setup</b>
        <ul>
          <li>
            <b>Business Size</b>
          </li>
          <li>
            <b>Industry Type</b>
          </li>
          <li>
            <b>Country</b>
          </li>
          <li>
            <b>Source</b>
          </li>
          <li>
            <b>Customer Group</b>
          </li>
        </ul>
      </Typography>
      <Typography paragraph variant="body1">
        <b>Sales Setup</b>
        <ul>
          <li>
            <b>Company Sales Target</b>
          </li>
          <li>
            <b>User Sales Target</b>
          </li>
          <li>
            <b>Cost Component</b>
          </li>
        </ul>
      </Typography>
      <Typography paragraph variant="body1">
        <b>Inventory Setup</b>
        <ul>
          <li>
            <b>Brand</b>
          </li>
          <li>
            <b>Category</b>
          </li>
          <li>
            <b>Uom</b>
          </li>
          <li>
            <b>Variant</b>
          </li>
        </ul>
      </Typography>
      <Typography paragraph variant="body1">
        <b>Operation Setup</b>
        <ul>
          <li>
            <b>Operation Type</b>
          </li>
          <li>
            <b>OLC Status</b>
          </li>
        </ul>
      </Typography>
      <Typography paragraph variant="body1">
        <b>Procurement Setup</b>
        <ul>
          <li>
            <b>Classification</b>
          </li>
        </ul>
      </Typography>
      <Typography paragraph variant="body1">
        <b>Finance Setup</b>
        <ul>
          <li>
            <b>Fiscal Year</b>
          </li>
          <li>
            <b>Currency</b>
          </li>
          <li>
            <b>GL Account</b>
          </li>
          <li>
            <b>Bank Account</b>
          </li>
          <li>
            <b>Tax</b>
          </li>
        </ul>
      </Typography>
      <Typography paragraph variant="body1">
        <b>Finance Setup</b>
        <ul>
          <li>
            <b>Approval</b>
          </li>
          <li>
            <b>Task Status</b>
          </li>
        </ul>
      </Typography>
      <Typography paragraph variant="body1">
        <b>Common Setup</b>
        <ul>
          <li>
            <b>Predefined ToC</b>
          </li>
          <li>
            <b>Document Code Prefix</b>
          </li>
        </ul>
      </Typography>
      <Typography paragraph variant="body1">
        <b>System Setup</b>
        <ul>
          <li>
            <b>Mail Channel</b>
          </li>
        </ul>
      </Typography>
      <Typography paragraph variant="body1">
        All the above configurations will appear only if the user has the
        authorization to access it. Besides, any standard records were prevented
        from being deleted by the user.
      </Typography>
    </React.Fragment>
  );
};

export default Setup;
